import React, { useState, useEffect } from "react";
import CmtCardContent from "@coremat/CmtCard/CmtCardContent";
import { Box, Button, Grid, TextField, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import CmtCardFooter from "@coremat/CmtCard/CmtCardFooter";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { Add } from "@material-ui/icons";
import { useDispatch } from "react-redux";
import CmtCard from "@coremat/CmtCard";
import GridContainer from "@jumbo/components/GridContainer";
import BannerReguests from "services/banner";
import TextEditor from "./TextEditor";
import CheckBox from "./CheckBox";
import CustomSelect from "./CustomSelect";
import CustomDatePicker from "../Gallery/components/datePicker";
import {
  convertToStandardFormat,
  dateFormat,
} from "@jumbo/utils/shamsiStandardFormat";
import FilePicker from "./FilePicker";
import SelectedFiles from "./SelectedFiles";

import AddBannerDialog from "./AddBannerDialog";
import EditBannerDialog from "./EditBannerDialog";
import DeleteBannerDialog from "./DeleteBannerDialog";
import gregorian from "react-date-object/calendars/gregorian";
import gregorian_en from "react-date-object/locales/gregorian_en";
import { DateObject } from "react-multi-date-picker";
import { fetchError } from "redux/actions";

const useStyles = makeStyles((theme) => ({
  cardContainer: {
    marginTop: 10,
  },
  titleInput: {
    width: "100%",
  },
  formControl: {
    width: "100%",
  },
  title: {
    color: theme.palette.primary.main,
    marginBlock: "16px",
    fontWeight: "bold",
  },
}));

const BannerElement = ({ banner }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [title, setTitle] = useState("");
  const [showtitle, setShowTitle] = useState(false);
  const [desc, setDesc] = useState("");
  const [highligted, setHighligted] = useState(false);
  const [bannerType, setbannerType] = useState("Image");
  const [position, setPosition] = useState("");
  const [link, setLink] = useState("");
  const [newWindow, setNewWindow] = useState(false);
  const [countDownTimer, setCountDownTimer] = useState(dateFormat);
  const [timerLable, setTimerLable] = useState("");
  const [showTimer, setshowTimer] = useState(false);
  const [numberInRow, setnumberInRow] = useState("");
  const [currMedia, setCurrMedia] = useState();
  const [bannerIndex, setBannerIndex] = useState("");
  const [tag, setTag] = useState("");

  const [openEditDialog, setopenEditDialog] = useState(false);
  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  useEffect(() => {
    if (!banner) {
      getIndex();
    }
  }, []);

  useEffect(() => {
    if (banner) {
      setTitle(banner.title);
      setShowTitle(banner.titleVisible);
      setDesc(banner.description);
      setPosition(banner.position);
      setbannerType(banner.type);
      setBannerIndex(banner.index);
      setLink(banner.link);
      setNewWindow(banner.linkNewTab);
      setHighligted(banner.highlight);
      setTag(banner?.tags || "");
      if (banner.timer) {
        setshowTimer(true);
        setCountDownTimer({
          date: banner.timer,
          gregorian: new DateObject({
            date: banner.eventDate,
            format: "HH:mm:ss   YYYY/MM/DD",
          })
            .convert(gregorian, gregorian_en)
            .format(),
        });
        setTimerLable(banner.timerLabel);
      }
      setnumberInRow(banner.rowCount);
      if (banner.type === "Image") {
        setCurrMedia(banner.src);
      } else if (banner.type === "Video") {
        setCurrMedia({ src: banner.src, preview: banner.videoCover });
      } else if (banner.srcList.length !== 0) {
        const data = banner.srcList.map((item) => {
          if (item.type === "Image") {
            return {
              type: "Image",
              file: item.src,
            };
          } else if (item.type === "Video") {
            return {
              type: "Video",
              file: { src: item.src, preview: item.videoCover },
            };
          }
        });
        setCurrMedia(data);
      }
    }
  }, [banner]);

  const resetState = () => {
    setTitle("");
    setShowTitle(false);
    setDesc("");
    setPosition("");
    setbannerType("Image");
    setBannerIndex("");
    setLink("");
    setNewWindow(false);
    setHighligted(false);
    setCountDownTimer(dateFormat);
    setTimerLable("");
    setnumberInRow("");
    setCurrMedia([]);
    setTag("");
  };

  const fillBannerFields = () => {
    const BannerData = {
      title: title,
      titleVisible: showtitle,
      description: desc,
      position: position,
      type: bannerType,
      index: bannerIndex,
      link: link,
      linkNewTab: newWindow,
      highlight: highligted,
      rowCount: numberInRow,
      tags: tag,
    };
    if (showTimer) {
      BannerData["timer"] = convertToStandardFormat(countDownTimer.gregorian);
      BannerData["timerLabel"] = timerLable;
    } else {
      BannerData["timer"] = "";
      BannerData["timerLabel"] = "";
    }
    if (bannerType === "Image") {
      BannerData["src"] = currMedia;
    } else if (bannerType === "Video") {
      BannerData["src"] = currMedia.src;
      BannerData["videoCover"] = currMedia.preview;
    } else {
      if (currMedia) {
        if (currMedia.length !== 0) {
          const data = currMedia.map((media) => {
            if (media.type === "Image") {
              return {
                src: media.file,
                type: media.type,
              };
            } else if (media.type === "Video") {
              return {
                src: media.file.src,
                type: media.type,
                videoCover: media.file.preview,
              };
            }
          });
          BannerData["srcList"] = data;
        }
      }
    }
    return BannerData;
  };

  const handleAddAndClose = () => {
    dispatch(BannerReguests.createBanner(fillBannerFields()))
      .then(() => {
        resetState();
      })
      .catch((error) => {
        dispatch(fetchError(error));
      });
    setOpenAddDialog(false);
  };

  const handleEditAndClose = () => {
    dispatch(
      BannerReguests.updateSingleBanner(
        banner._id || banner.id,
        fillBannerFields()
      )
    );
    setopenEditDialog(false);
  };

  const handleClose = () => {
    setOpenDialog(false);
  };

  const handleRemoveAndClose = () => {
    dispatch(BannerReguests.removeSingleBanner(banner._id || banner.id));
    setOpenDialog(false);
  };

  const deleteHandler = (file) => {
    if (bannerType === "Image") {
      setCurrMedia("");
    } else if (bannerType === "Video") {
      setCurrMedia("");
    } else if (bannerType === "Array") {
      const mediaCopy = currMedia.filter((element) => {
        if (element.type === "Image") {
          return element.file !== file;
        } else {
          return element.file.src !== file;
        }
      });
      setCurrMedia(mediaCopy);
    }
  };

  const options = [
    { value: "Image", text: "عکس" },
    { value: "Video", text: "ویدئو" },
  ];
  if (position !== "Top") {
    options.push({ value: "Array", text: "مجموعه" });
  } else {
    options.filter((val) => val.value !== "Array");
  }

  const handleFillMediaList = (val) => {
    if (banner.type === "Image" && val === "Image") {
      setCurrMedia(banner.src);
    } else if (banner.type === "Video" && val === "Video") {
      setCurrMedia({
        src: banner.src,
        preview: banner.VideoCover,
      });
    } else if (banner.srcList.length !== 0 && val === "Array") {
      const data = banner.srcList.map((item) => {
        if (item.type === "Image") {
          return {
            type: "Image",
            file: item.src,
          };
        } else if (item.type === "Video") {
          return {
            type: "Video",
            file: {
              src: item.src,
              preview: item.VideoCover,
            },
          };
        }
      });
      setCurrMedia(data);
    } else {
      setCurrMedia([]);
    }
  };

  async function getIndex() {
    try {
      const index = await BannerReguests.getSuggestedIndex();
      setBannerIndex(index);
    } catch (error) {
      console.log("Error loading statistics:", error);
    }
  }

  return (
    <React.Fragment>
      <div className={classes.cardContainer}>
        <CmtCard>
          <CmtCardContent>
            <GridContainer>
              <Grid item xs={12} md={6}>
                <Grid item xs={12}>
                  <TextField
                    id="title"
                    label="عنوان"
                    variant="outlined"
                    className={classes.titleInput}
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <CheckBox
                    name={"showTitle"}
                    title={"نمایش عنوان"}
                    value={showtitle}
                    handleChange={() => setShowTitle((prev) => !prev)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <CheckBox
                    name={"highligted"}
                    title={"هایلایت"}
                    value={highligted}
                    handleChange={() => setHighligted((prev) => !prev)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography className={classes.title}>توضیحات</Typography>
                  <TextEditor
                    data={desc}
                    handleChange={(data) => setDesc(data)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <CustomSelect
                    title={"نوع بنر"}
                    value={bannerType}
                    handleChange={(val) => {
                      setbannerType(val);
                      if (banner) {
                        handleFillMediaList(val);
                      } else {
                        setCurrMedia([]);
                      }
                    }}
                    options={options}
                  />
                </Grid>
                <Grid item xs={12}>
                  <CustomSelect
                    title={"محل قرارگیری"}
                    value={position}
                    handleChange={(val) => setPosition(val)}
                    options={[
                      { value: "Top", text: "بالا" },
                      { value: "Bottom", text: "پایین" },
                      { value: "Archived", text: "آرشیو شده" },
                    ]}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography className={classes.title}>تگ</Typography>
                  <TextField
                    id="tag"
                    label="تگ"
                    variant="outlined"
                    className={classes.formControl}
                    value={tag}
                    onChange={(e) => setTag(e.target.value)}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography className={classes.title}>لینک</Typography>
                  <TextField
                    id="socoreField"
                    label="لینک"
                    variant="outlined"
                    className={classes.formControl}
                    value={link}
                    onChange={(e) => setLink(e.target.value)}
                  />
                </Grid>
                {link && (
                  <Grid item xs={12}>
                    <CheckBox
                      name={"newWindow"}
                      title={"پنجره جدید"}
                      value={newWindow}
                      handleChange={() => setNewWindow((prev) => !prev)}
                    />
                  </Grid>
                )}
                <Grid item xs={12}>
                  <CheckBox
                    name={"showTimer"}
                    title={"شمارشگر"}
                    value={showTimer}
                    handleChange={() => setshowTimer((prev) => !prev)}
                  />
                </Grid>
                {showTimer && (
                  <>
                    <Grid item xs={12} style={{ marginTop: "16px" }}>
                      <CustomDatePicker
                        title={"شمارش گر معکوس"}
                        value={countDownTimer}
                        setValue={setCountDownTimer}
                      />
                    </Grid>
                    <Grid item xs={12}>
                      <Typography className={classes.title}>
                        عنوان شمارشگر
                      </Typography>
                      <TextField
                        id="socoreField"
                        label="عنوان شمارشگر"
                        variant="outlined"
                        className={classes.formControl}
                        value={timerLable}
                        onChange={(e) => setTimerLable(e.target.value)}
                      />
                    </Grid>
                  </>
                )}
                <Grid item xs={12}>
                  <Typography className={classes.title}>ایندکس</Typography>
                  <TextField
                    id="index"
                    label="ایندکس"
                    variant="outlined"
                    type="number"
                    className={classes.formControl}
                    value={bannerIndex}
                    onChange={(e) => setBannerIndex(e.target.value)}
                    onWheel={(e) => e.target.blur()}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography className={classes.title}>
                    تعداد در سطر
                  </Typography>
                  <TextField
                    id="number in row"
                    label="تعداد در سطر"
                    variant="outlined"
                    type="number"
                    className={classes.formControl}
                    value={numberInRow}
                    onChange={(e) => setnumberInRow(e.target.value)}
                    onWheel={(e) => e.target.blur()}
                  />
                </Grid>
              </Grid>
              <Grid item xs={12} md={6}>
                <FilePicker type={bannerType} setCurrMedia={setCurrMedia} />
                {currMedia && currMedia.length !== 0 ? (
                  <SelectedFiles
                    media={currMedia}
                    type={bannerType}
                    handleDelete={(data) => deleteHandler(data)}
                  />
                ) : null}
              </Grid>
            </GridContainer>
          </CmtCardContent>

          <CmtCardFooter
            separator={{
              color: "#bdbdbd",
              borderWidth: 1,
              borderStyle: "solid",
            }}
          >
            <Box>
              {banner ? (
                <>
                  <Button
                    variant="contained"
                    color="secondary"
                    startIcon={<DeleteIcon />}
                    onClick={() => setOpenDialog(true)}
                    style={{ marginRight: 14 }}
                  >
                    حذف
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<EditIcon />}
                    onClick={() => setopenEditDialog(true)}
                    style={{ marginRight: 14 }}
                  >
                    ویرایش
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    variant="outlined"
                    color="primary"
                    startIcon={<Add />}
                    onClick={() => setOpenAddDialog(true)}
                    style={{ marginRight: 14 }}
                  >
                    ایجاد بنر جدید
                  </Button>
                </>
              )}
            </Box>
          </CmtCardFooter>
        </CmtCard>
      </div>

      <DeleteBannerDialog
        show={openDialog}
        handleClose={handleClose}
        handleRemoveAndClose={handleRemoveAndClose}
      />
      <AddBannerDialog
        show={openAddDialog}
        handleClose={() => setOpenAddDialog(false)}
        handleAddAndClose={handleAddAndClose}
      />
      <EditBannerDialog
        show={openEditDialog}
        handleClose={() => setopenEditDialog(false)}
        handleEditAndClose={handleEditAndClose}
      />
    </React.Fragment>
  );
};

export default BannerElement;
